export const SET_DATA = "@LOGS/SET_DATA";
export const SET_FORMATTED = "@LOGS/SET_FORMATTED";
export const READ = "@LOGS/READ";
export const READ_FAIL = "@LOGS/READ_FAIL";
export const READ_SUCCESS = "@LOGS/READ_SUCCESS";
export const REQUEST_READ = "@LOGS/REQUEST_READ";
